'use client';
import { Entering, Loading, TabBar, Typography } from 'components';
import useTabs from 'hooks/useTabs';
import { useTranslations } from 'next-intl';
import { FC, PropsWithChildren, useEffect, useState } from 'react';
import { cn } from 'utils/cn';

const BillingLayout: FC<PropsWithChildren<unknown>> = ({ children }) => {
  const t = useTranslations();
  const [loading, setLoading] = useState(true);

  const { tabs, activeTabIndex } = useTabs({
    context: 'billing',
    routes: ['transactions', 'invoices', 'payments', 'orders', 'info']
  });

  useEffect(() => {
    setLoading(false);
  }, []);

  if (loading) return <Loading />;

  return (
    <>
      <div
        className={cn(
          'w-7xl sticky top-20 z-50 w-[calc(100%_-_4px)] max-w-7xl bg-[hsl(200deg_60%_98.04%_/_0%)]',
          'backdrop-blur-md transition-colors duration-200 ease-in-out',
          'pt-10 md:ml-1 md:pl-3 md:pr-8 lg:ml-1 lg:pl-[28px] lg:pr-8'
        )}
      >
        <Entering position="top" delay={0} duration={0.2} offset={20}>
          <div className="flex w-full flex-row">
            <Typography
              variant="medium7xl"
              className="relative left-0 top-0 text-tertiary-100 dark:text-white"
            >
              {t('billing.title')}
            </Typography>
          </div>
        </Entering>
        <TabBar tabs={tabs} activeTabIndex={activeTabIndex} />
      </div>
      <Entering position="top" delay={0.6} duration={0.2} offset={20}>
        <div className="md:mx-4 lg:mx-8">{children}</div>
      </Entering>
    </>
  );
};

export default BillingLayout;
